import { countBy } from 'lodash';
import { RecipeComplexity, ComplexitiesResponse } from '../../../types';
import { inMemoryRecipes } from './inMemoryRecipes';

export const inMemoryComplexities: ComplexitiesResponse = Object.entries(countBy(inMemoryRecipes, (recipe) => recipe.complexity)).map(
  ([complexity, recipesCount]) => ({ complexity: complexity as RecipeComplexity, recipesCount })
);
